<script>
import BaseModal from 'dashboard/components/dahreply/BaseModal.vue';

export default {
  props: {
    deleteName: {
      type: String,
      default: "this item"
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  components: {
    BaseModal
  },
  methods: {
    handleConfirm(){
      this.$emit('confirm');
    }
  }
}
</script>

<template>
  <BaseModal @close="$emit('close')">
    <template #title>
      <span class="text-red-500">Delete Confirmation</span>
    </template>

    <p>
      Are you sure you want to delete 
      <span class="text-red-500 font-bold">{{ deleteName }}</span>?
    </p>
    <!-- Optional extra note under the question (e.g. a side effect). -->
    <slot />

    <template #footer>
      <div class="flex justify-end gap-3 mt-4">
        <woot-button color-scheme="secondary" @click="$emit('close')" :disabled="isLoading">
          Cancel
        </woot-button>
        <woot-button @click="handleConfirm" :disabled="isLoading" :loading="isLoading" color-scheme="alert">
          Confirm
        </woot-button>
      </div>
    </template>
  </BaseModal>
</template>